import { TabDataItem, Tabs } from "@/components";
import React from "react";

export interface HSPEquipmentProps {
  data: TabDataItem[];
  title?: string;
}

export const HSPEquipment: React.FC<HSPEquipmentProps> = ({ data }) => {

  if (!data || data.length === 0) {
    return (
      <div className="mt-6 space-y-8 lg:mt-10">
        <div className="py-8 text-center text-gray-500">
          Brak danych o wyposażeniu
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 space-y-8 lg:mt-10">
      <Tabs
        data={data}
        defaultValue={
          data[0]?.title?.toLowerCase().replace(/\s+/g, "-") || "wyposazenie"
        }
        className="mt-6"
        contentSize="wide"
        prefix="wyposazenie"
      />
    </div>
  );
};
